export default __webpack_public_path__ + "static/media/desktop_hero_01.e7ed0c94.gif";